import React, { useState } from 'react';
import { Modal, Box, Button, Typography, CircularProgress } from '@mui/material';

const FileUploadModal = ({ open, onClose, onFileUpload }) => {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const handleUpload = async () => {
    if (!file) {
      alert('Por favor, selecciona un archivo para cargar.');
      return;
    }
    setUploading(true);
    try {
      // Llamamos a la función del padre que se encargará de subir el archivo (retorna una promesa).
      await onFileUpload(file);
      // Después de subir correctamente, cerramos el modal y limpiamos el estado.
      setFile(null);
      onClose();
    } catch (error) {
      console.error('Error subiendo archivo desde el modal:', error);
      // Maneja el error como necesites
    } finally {
      setUploading(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={{ ...modalStyle }}>
        <Typography variant="h6" gutterBottom>
          Cargar Archivo
          (Los formatos de archivos permitidos son jpeg, jpg, png y pdf)
        </Typography>

        {/* Si está subiendo, mostramos el spinner, si no, mostramos el input y botón */}
        {uploading ? (
          <Box display="flex" justifyContent="center" alignItems="center" marginTop={2}>
            <CircularProgress />
          </Box>
        ) : (
          <>
            <input type="file" onChange={handleFileChange} />
            <Button onClick={handleUpload} variant="contained" color="primary" sx={{ ml: 2 }}>
              Cargar
            </Button>
          </>
        )}
      </Box>
    </Modal>
  );
};

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default FileUploadModal;
